const { default: ynToBool } = require("./ynToBool");

export const handleObjectAddress = (Cart, Participants) => {
  return { 
    name: {
      value: Cart?.cart?.customer?.name || Participants?.name?.value,
      disabled: ynToBool(Participants?.name?.disabled)
    },
    street: {
      value: Cart?.cart?.shippingAddress?.street || Participants?.address?.addressText?.value,
      disabled: ynToBool(Participants?.address?.addressText?.disabled) 
    },
    number: {
      value: Cart?.cart?.shippingAddress?.number || Participants?.address?.number?.value,
      disabled: ynToBool(Participants?.address?.number?.disabled) 
    },
    reference: {
      value: Cart?.cart?.shippingAddress?.reference || Participants?.address?.reference?.value,
      disabled: ynToBool(Participants?.address?.reference?.disabled) 
    },
    complement: {
      value: Cart?.cart?.shippingAddress?.complement || Participants?.address?.complement?.value,
      disabled: ynToBool(Participants?.address?.complement?.disabled) 
    },
    district: {
      value: Cart?.cart?.shippingAddress?.district || Participants?.address?.district?.value,
      disabled: ynToBool(Participants?.address?.district?.disabled) 
    },
    city: {
      value: Cart?.cart?.shippingAddress?.city || Participants?.address?.city?.value,
      disabled: ynToBool(Participants?.address?.city?.disabled) 
    },
    state: {
      value: Cart?.cart?.shippingAddress?.state || Participants?.address?.state?.value,
      disabled: ynToBool(Participants?.address?.state?.disabled) 
    },
    zipCode: {
      value: Cart?.cart?.shippingAddress?.zipCode || Participants?.address?.zipCode?.value,
      disabled: ynToBool(Participants?.address?.zipCode?.disabled) 
    }
  };
}